import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["extra", "button"]

  toggle() {
    const isHidden = this.extraTarget.classList.contains("hidden")
    this.extraTarget.classList.toggle("hidden")
    this.buttonTarget.textContent = isHidden ? "Show less" : "Show more"
  }
}
